<template>
  <b-row align-h="center" class="mt-3">
    <b-col md="6">
      <b-card>
        <h3>Reset Password</h3>
        <hr>
        <div v-if="tokenIsValid">
          <px-text-entry-box id="password"
                             v-model="password"
                             :is-horizontal="true"
                             :validation="$v.password"
                             placeholder="Enter your password."
                             title-text="Password"
                             type="password" />

          <px-text-entry-box id="password2"
                             v-model="password2"
                             :is-horizontal="true"
                             :validation="$v.password2"
                             placeholder="Reenter your password for verification."
                             title-text="Reenter Password"
                             type="password" />

          <b-button @click="savePassword()">Save new password</b-button>
        </div>

        <div v-if="!tokenIsValid">
          <alert show variant="danger">
            Password reset token could not be authenticated.
          </alert>
        </div>
        <error-display/>
      </b-card>
    </b-col>
  </b-row>
</template>

<script>
  import {$http} from "@/main";
  import {userStore} from "@/store/store";
  import PxTextEntryBox from "@/views/components/input/formFields/PxTextEntryBox";
  import ErrorDisplay from "@/views/components/projects/ErrorDisplay";
  import {Component, Vue} from 'vue-property-decorator';
  import {minLength, required, sameAs} from "vuelidate/lib/validators";

  @Component({
    components: {ErrorDisplay, PxTextEntryBox},
    validations: {
      password: {
        required,
        minLength: minLength(6)
      },
      password2: {
        sameAs: sameAs('password')
      }
    }
  })
  export default class ResetPassword extends Vue {

    password = "";
    password2 = "";

    tokenIsValid = false;

    get token() {
      return this.$route.query.token;
    }

    created(){
      $http.post('password_reset/validate_token/', {token: this.token}).then(response=> {
        if (response.status === 200){
          this.tokenIsValid = true
        }
      }).catch(reason => userStore.pushHttpErrors(reason))
    }

    savePassword(){
      this.$v.$touch();
      if (!this.$v.$anyError){
        $http.post('password_reset/confirm/', {password: this.password, token: this.token}).then(response => {
          if (response.status === 200){
            this.$router.push('login')
          }
        }).catch(reason => userStore.pushHttpErrors(reason))
      }


    }

  }

</script>

<style lang="scss" scoped>

  #background-image {
    background: black url('../assets/home-page-1.jpg') no-repeat center center fixed;
    -webkit-background-size: cover;
    -moz-background-size: cover;
    -o-background-size: cover;
    background-size: cover;
    height: 775px;
    opacity: 0.5;
  }

</style>
